import React, { useState, useEffect } from "react";
import RichTextEditor from "react-rte";

function ShortAnswer({ item, updateItem, lang }) {
  const [fieldType, setFieldType] = useState("textbox");
  const [minCharacters, setMinCharacters] = useState(1);
  const [maxCharacters, setMaxCharacters] = useState(1000);
  const [testText, setTestText] = useState("");
  const [editorState, setEditorState] = useState(
    RichTextEditor.createValueFromString(item.contents?.q ? item.contents?.q[lang.code] : "", "html")
  );

  useEffect(() => {
    let temp = item;
    temp.contents.fieldType = temp.contents.fieldType || "textbox";
    updateItem("temp");
  }, []);

  useEffect(() => {
    setFieldType(item.contents?.fieldType || "textbox");
    setMinCharacters(item.contents?.minCharacters || 1);
    setMaxCharacters(item.contents?.maxCharacters || 1000);
    setTestText("");
  }, [item]);

  useEffect(() => {
    setStateOfEditor();
  }, [lang]);

  function setStateOfEditor() {
    setEditorState(RichTextEditor.createValueFromString(item.contents?.q?.[lang.code] || "", "html"));
  }

  function handleEditorValueChange(value) {
    setEditorState(value);
    let temp = item;

    if (value.toString("html") === "<p><br></p>") {
      temp.contents.q[lang.code] = "";
    } else {
      temp.contents.q[lang.code] = value.toString("html");
    }

    updateItem({ ...item });
  }

  function changeFieldType(type) {
    let temp = item;

    temp.contents.fieldType = type;
    updateItem({ ...temp });

    setFieldType(type);
  }

  function changeMinCharacters(e) {
    const { value } = e.target;
    if (value > maxCharacters) return;
    let temp = item;

    temp.contents.minCharacters = parseInt(e.target.value);
    updateItem({ ...temp });

    setMinCharacters(Math.max(1, value));
  }

  function changeMaxCharacters(e) {
    let temp = item;

    temp.contents.maxCharacters = parseInt(e.target.value);
    updateItem({ ...temp });

    setMaxCharacters(Math.min(10000, e.target.value));
  }

  function changeTestText(e) {
    setTestText(e.target.value);
  }

  return (
    <div className="QM-question__contents-editor" id={item.type}>
      <div className="QM-question__main-properties">
        <div className="QM-question__question">
          <p>Question</p>
          <RichTextEditor value={editorState} onChange={handleEditorValueChange} />
        </div>
        <div className="QM-question__answer-list">
          <div className="QM-question__answer-list-label">
            <p>Answers</p>
          </div>
          <div className="QM__shortAnswer__answer-options-container">
            <label>
              <input
                type="radio"
                name="shortAnswerType"
                checked={fieldType === "textbox"}
                value="textbox"
                onChange={() => changeFieldType("textbox")}
              />{" "}
              Regular text box (very short answer, sentence-length or less)
            </label>
            <label>
              <input
                type="radio"
                name="shortAnswerType"
                checked={fieldType === "textarea"}
                value="textbox"
                onChange={() => changeFieldType("textarea")}
              />{" "}
              Resizable text area (longer answer)
            </label>
            <div className="QM__shortAnswer__character-limit-container">
              <label>
                <input type="number" id="min" min={1} value={minCharacters} onChange={changeMinCharacters} /> Minimum
                characters
              </label>
              <label>
                <input
                  type="number"
                  id="max"
                  min={minCharacters}
                  max={10000}
                  value={maxCharacters}
                  onChange={changeMaxCharacters}
                />{" "}
                Maximum characters
              </label>
            </div>
          </div>
        </div>
        <div className="QM__short-answer__test-container">
          <div className="QM__short-answer__test-container-label">
            <span>Preview</span>
            <span className="short-answer__character-count-label">
              <span
                className={`short-answer__character-count ${
                  testText.length < minCharacters || testText.length > maxCharacters ? "invalid" : ""
                }`}
              >
                {testText.length}
              </span>{" "}
              / {maxCharacters} characters
            </span>
          </div>
          {fieldType === "textbox" && (
            <input type="text" value={testText} onChange={changeTestText} placeholder="Type some text here" />
          )}
          {fieldType === "textarea" && (
            <textarea value={testText} onChange={changeTestText} placeholder="Type some text here" />
          )}
        </div>
      </div>
    </div>
  );
}

export default ShortAnswer;
